<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-container" @click.stop>
      <button @click="closeModal" class="close-button" type="button">
        <img src="../../assets/images/cross.svg">
      </button>

      <div class="modal-header">
        <h2 class="modal-title">{{ $t('product_description') }}</h2>
      </div>

      <div class="modal-content">
        <p>{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescriptionModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    description: {
      type: String,
      default: ''
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.modal-container {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 12px;
  transition: background 0.2s ease;
  z-index: 1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  background: #F3F4F6;
}

.modal-header {
  padding: 24px 24px 16px;
  border-bottom: 1px solid #EAECF0;
}

.modal-title {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  color: #101828;
  margin: 0;
}

.modal-content {
  padding: 24px;
  overflow-y: auto;
  max-height: calc(80vh - 100px);
}

.modal-content p {
  font-size: 14px;
  color: #374151;
  margin: 0;
}
</style>
